const state = {
  translationStatus: ''
};

const mutations = {
  SET_TRANSLATION_STATUS(state, status) {
    state.translationStatus = status;
  }
};

const actions = {
  initialize() {},
  initTranslationStatus(
    { dispatch, commit, state: { translationStatus } },
    defaultTranslationStatus
  ) {
    commit('SET_TRANSLATION_STATUS', defaultTranslationStatus);
    dispatch(
      'googleTranslator/inheritTranslationStatus',
      translationStatus || defaultTranslationStatus,
      { root: true }
    );
  },
  changeTranslationStatus({ commit }, translationStatus) {
    commit('SET_TRANSLATION_STATUS', translationStatus);
  }
};

export default { namespaced: true, state, mutations, actions };
